import { Actions } from '../constants';

export default function displayMobileNav() {
  return {
    type: Actions.DISPLAY_MOBILE_NAV,
  };
}
